import { Button, Chip, Grid, Stack, Typography, useTheme } from "@mui/material";
import { MenuProps as MenuPropsType } from "@mui/material/Menu";
import { Box } from "@mui/system";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { ActivityCard } from "../components/ActivityCard/ActivityCard";
import { actionCreators, RootState } from "../state";
import { Technologies } from "../types/activityType";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps: Partial<MenuPropsType> = {
    variant: "menu",
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export const ActivitiesPreviewer = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const activities = useSelector((state: RootState) => state.activities.array);
    const { addActivities, setActivities } = bindActionCreators(actionCreators, dispatch);

    const titleRef = useRef<any>();

    const [selectedTechnologies, setSelectedTechnologies] = useState<string[]>(Object.keys(Technologies));

    function handleBackClick() {
        titleRef.current.scrollIntoView({ behavior: "smooth" });
    }

    const handleFilterChange = (techKeys: string[], forceSelection?: boolean) => {
        if (forceSelection) return setSelectedTechnologies(techKeys);

        setSelectedTechnologies((prev) => {
            let result = [...prev];
            techKeys.forEach((tech) => {
                if (result.includes(tech)) return (result = result.filter((e) => e !== tech));
                return (result = [...result, tech]);
            });
            return result;
        });
    };

    // const handleDelete = (ev: any, techKey: string) => {
    //     console.log("delete called");
    //     setSelectedTechnologies((prev) => prev.filter((e) => techKey !== e));
    // };

    // const executeScroll = () => myRef.current.scrollIntoView();

    return (
        <Box padding={{ xs: 1, sm: 2 }} ref={titleRef}>
            <Stack direction={"row"} spacing={theme.spacing(1)} alignItems="center" marginBottom={theme.spacing(1)}>
                <Typography variant="h4" sx={{ mb: 1 }}>
                    Progetti
                </Typography>
                {Object.keys(Technologies).map((techKey, index) => (
                    <Chip
                        key={techKey}
                        label={techKey}
                        variant="filled"
                        color={selectedTechnologies.includes(techKey) ? "primary" : "default"}
                        onClick={(ev) => handleFilterChange([techKey])}
                    />
                ))}
                <Button
                    variant="contained"
                    onClick={() =>
                        handleFilterChange(
                            selectedTechnologies.length === Object.keys(Technologies).length
                                ? []
                                : Object.keys(Technologies),
                            true
                        )
                    }
                >
                    {selectedTechnologies.length === Object.keys(Technologies).length ? "Deselect All" : "Select All"}
                </Button>
            </Stack>
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, xl: 12 }}>
                {activities
                    .filter((activity) => selectedTechnologies.includes(activity.technology))
                    .map((e, i) => {
                        return (
                            <Grid item xs={4} sm={4} md={3} xl={2} key={i}>
                                <ActivityCard content={e} />
                            </Grid>
                        );
                    })}
            </Grid>
        </Box>
    );
};
